import React from 'react';

import Icon from '@material-ui/icons/Error';

const IconError = ({style}) => {
	return <Icon style={{...style, color: '#F14242'}} />;
};

export default IconError;
